import clsx from "clsx";

const SIGN = { pos: "text-success-ink", neg: "text-danger" };

// Mock `.sale-focus`: a lead sentence with an action, then the trading result as one equation row
// (`A − B + C = D`, each term may carry the operator before it) and the hints under it.
function SaleFocus({ title, head, action, terms = [], note, tone = "default" }) {
  return (
    <section
      data-testid="sale-focus"
      data-tone={tone}
      aria-label={title}
      className={clsx(
        "flex flex-col gap-3 rounded-xl border border-border px-4 py-3.5",
        tone === "warn" ? "shadow-[inset_3px_0_0_rgb(var(--warn))]" : "shadow-[inset_3px_0_0_rgb(var(--accent-solid))]",
      )}>
      {(head || action) && (
        <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 text-sm text-text">
          {head && <p className="max-w-[560px]">{head}</p>}
          {action}
        </div>
      )}
      <dl data-testid="sale-equation" className="num flex flex-wrap items-end gap-x-3 gap-y-2">
        {terms.map((t) => (
          <div key={t.label} className="contents">
            {t.op && (
              <span aria-hidden="true" className="pb-px text-base text-text-muted">
                {t.op}
              </span>
            )}
            <div
              data-testid="sale-term"
              data-emphasis={t.emphasis ? "true" : undefined}
              className={clsx(
                "flex flex-col gap-0.5",
                t.emphasis && "-my-1.5 rounded-[10px] bg-[color-mix(in_srgb,rgb(var(--accent-solid))_9%,rgb(var(--surface)))] px-2.5 py-1.5",
              )}>
              <dt className="text-[11px] font-medium text-text-muted">{t.label}</dt>
              <dd className={clsx("text-base font-semibold", SIGN[t.sign] || "text-text")}>{t.value}</dd>
            </div>
          </div>
        ))}
      </dl>
      {note && <div className="flex flex-col gap-1 text-xs text-text-muted">{note}</div>}
    </section>
  );
}

export default SaleFocus;
